import {
    ADD_FEED_CLOSE,
    ADD_FEED_MODERATE,
    ADD_FEED_PREVIEW_REQUEST,
    ADD_FEED_PREVIEW_RESPONSE,
    ADD_FEED_PREVIEW_TYPING,
    ADD_FEED_TOGGLE_REJECTION_REASON_MODAL,
    ADD_FEED_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    ADD_FEED_ANALYSE_REQUEST as ITEM_REQUEST,
    ADD_FEED_ANALYSE_RESPONSE as ITEM_RESPONSE,
    ADD_FEED_UPDATE_IMAGE as UPDATE_IMAGE,
    ADD_FEED_UPDATE_MODEL as UPDATE_MODEL
} from "../../actions/action-types"
import {
    toUI as feedToUI,
    updateFeedChangeModel,
    FeedModel
} from "../../models/entities/feed"
import {
    toWebLink,
    getKnowledgeErrorMessage
} from "../../epics/default-epics/epic-utils"
import PresentationReducerBuilder from "./build-presentation-reducer"

const defaultState = {
    workingModel: new FeedModel(),
    hasPreviewLoaded: false,
    hasAnalysisCompleted: false,
    isFetchingPreview: false,
    dataToAnalyse: "",
    previewURL: "",
    error: null,
    errorMessage: null
}
const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        ITEM_REQUEST,
        ITEM_RESPONSE
    })
    .updateChangeModel(updateFeedChangeModel)
    .workingModelToUI(feedToUI)
    .workingModelClass(FeedModel)
    .defaultState(defaultState)
    .build()

export default (state = undefined, action) => {
    const defaultReduction = defaultReducer(state, action)
    const { type, previewURL, data, error } = action
    switch (type) {
        case ITEM_REQUEST:
            return {
                ...defaultReduction,
                error: null,
                errorMessage: null,
                hasAnalysisCompleted: false
            }
        case ITEM_RESPONSE:
            return {
                ...defaultReduction,
                error,
                errorMessage: getKnowledgeErrorMessage(error),
                hasAnalysisCompleted: !error,
                // The preview card no longer relies on an iframe onLoad event
                // to clear the loading state, so resolve it here when the
                // analysis (the actual scrape) finishes.
                isFetchingPreview: false,
                hasPreviewLoaded: true,
                activeId: data.id,
                canSave: !data.id && !error,
                isEditMode: !!data.id,
                fulltext: data.fulltext
            }
        case ADD_FEED_MODERATE:
            return {
                ...defaultReduction,
                isSavingItem: true
            }
        case ADD_FEED_PREVIEW_REQUEST:
            const isWebLink = !!toWebLink(previewURL)
            return {
                ...defaultReduction,
                dataToAnalyse: previewURL,
                // Only a web link gets a preview card; other input is rejected with an error message instead.
                previewURL: isWebLink ? previewURL : "",
                isFetchingPreview: isWebLink,
                hasPreviewLoaded: !isWebLink
            }
        case ADD_FEED_PREVIEW_TYPING:
            return {
                ...defaultReduction,
                dataToAnalyse: previewURL
            }
        case ADD_FEED_PREVIEW_RESPONSE:
            return {
                ...defaultReduction,
                isFetchingPreview: false,
                hasPreviewLoaded: true
            }
        case ADD_FEED_CLOSE:
            return defaultState
        case ADD_FEED_TOGGLE_REJECTION_REASON_MODAL:
            const { isRejectReasonModalOpen } = defaultReduction
            return {
                ...defaultReduction,
                isRejectReasonModalOpen: !isRejectReasonModalOpen
            }
        default:
            return defaultReduction
    }
}
